import React from 'react';

const UploadFile = () => {
  return (
    <div>
      <h2>Upload a File</h2>
      <form action="http://localhost:8000/upload" method="POST" encType="multipart/form-data">
        <label htmlFor="file">Choose a file:</label>
        <input type="file" id="file" name="file" accept=".pdf, .doc, .docx" required />
        <p>Accepted file formats: PDF, MS Word (.doc, .docx)</p>
        <input type="submit" value="Upload File" />
      </form>
    </div>
  );
}

export default UploadFile;
